import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface IFRSQuestionResponseOptionDTO {
  id: string;
  fileType: string;
  answerFileUrl: string;
  responseData?: any;
}

export interface IFRSQuestionResponseOptionsMetaDTO {
  total: number;
  page: number;
  lastPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetIFRSQuestionResponseOptionsResponse {
  data: IFRSQuestionResponseOptionDTO[];
  meta: IFRSQuestionResponseOptionsMetaDTO;
}

interface GetIFRSQuestionResponseOptionsParams {
  page?: number;
  limit?: number;
  sort?: "asc" | "desc";
}

type GetIFRSQuestionResponseOptionsAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: GetIFRSQuestionResponseOptionsResponse;
};

export const GetIFRSQuestionResponseOptions = async (
  questionId: string,
  {
    page = 1,
    limit = 10,
    sort = "asc",
  }: GetIFRSQuestionResponseOptionsParams = {}
): Promise<GetIFRSQuestionResponseOptionsAPIResponse> => {
  try {
    const response = await axios.get(
      `/ifrs-question/${questionId}/response-options`,
      {
        params: { page, limit, sort },
      }
    );
    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
